export default __webpack_public_path__ + "static/29-56958916b8e8ad537c44fd6718b8e239.png";